import { APIS } from 'scbk-card/constants/apiPaths';
import listCard from './kr/cardList.json';
import getHdExpectedPaymentAmount from './kr/hdExpectedPaymentAmount.json';
import listHdTransaction from './kr/hdTransactionList.json';
import settingsCodeList from './kr/settingsCodeList.json';

export const MockConfig = {
    ['/auth/settings/code/list']: () => settingsCodeList,
    [APIS.holdings.cards.inquiry.listHdTransaction]: () => listHdTransaction,
    [APIS.holdings.cards.inquiry.getHdExpectedPaymentAmount]: () => getHdExpectedPaymentAmount,
    [APIS.holdings.cards.inquiry.listCard]: () => listCard,
};
